import { Controller } from "@hotwired/stimulus"

// グループ内のチェックボックスを一括ON/OFFする。
// search_controller で絞り込み中は表示中の行だけを対象にする。
// 0件のグループでは master チェックボックスが描画されないため、master が無ければ何もしない
export default class extends Controller {
  static targets = ["master", "item"]

  connect() {
    this.refresh()
  }

  toggleAll() {
    if (!this.hasMasterTarget) return
    const checked = this.masterTarget.checked
    this.visibleItems().forEach((box) => {
      box.checked = checked
    })
  }

  refresh() {
    if (!this.hasMasterTarget) return
    const items = this.visibleItems()
    const checkedCount = items.filter((box) => box.checked).length
    this.masterTarget.checked = items.length > 0 && checkedCount === items.length
    this.masterTarget.indeterminate = checkedCount > 0 && checkedCount < items.length
  }

  visibleItems() {
    return this.itemTargets.filter((box) => {
      const row = box.closest('[data-search-target="row"]')
      return !row || row.style.display !== "none"
    })
  }
}
